import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useLogin from "hooks/useLogin";
import { CircularProgress, Stack } from "@mui/joy";
import DefaultPage from "./container/DefaultPage";

const KakaoLoginRedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams.get("code");
  const hasCalledLogin = useRef(false);

  const login = useLogin({
    url: "/user/login",
    code: code!!,
    type: "kakao",
    redirectUri: `${window.location.origin}/oauth/kakao`,
  });

  useEffect(() => {
    // StrictMode에서 중복 호출 방지
    if (hasCalledLogin.current) return;

    if (!code) {
      console.error("[Kakao Login] Authorization code가 없습니다.");
      navigate("/login", { replace: true });
      return;
    }

    hasCalledLogin.current = true;

    // Authorization code를 사용한 후 URL에서 즉시 제거하여
    // 새로고침/뒤로가기 시 재사용 방지
    window.history.replaceState({}, document.title, "/oauth/kakao");

    login();
  }, [code, login, navigate]);

  return (
    <DefaultPage
      content={
        <Stack alignItems={"center"}>
          <CircularProgress color="neutral" />
        </Stack>
      }
    />
  );
};

export default KakaoLoginRedirect;
